import navigationReducer from './navigationReducer';
import layoutReducer from './layoutReducer';
import folderLoadingReducer from './folderLoadingReducer';
import livePersonaCardReducer from './livePersonaCardReducer';
import asyncDialogReducer from './asyncDialogReducer';
import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import type { AppViewState } from '../../state';
import hubEditorsReducer from './hubEditorsReducer';
import mailComposeReducer from './mailComposeReducer';
import editContactOptionsReducer from './editContactOptionsReducer';
import pendingActionsStateReducer from './pendingActionsStateReducer';

const reducer: Reducer<AppViewState> = combineReducers<AppViewState>({
    navigationState: navigationReducer,
    layoutState: layoutReducer,
    livePersonaCardInitializationState: livePersonaCardReducer,
    contactFoldersLoadingState: folderLoadingReducer,
    asyncDialogState: asyncDialogReducer,
    createEditMode: hubEditorsReducer,
    mailComposeState: mailComposeReducer,
    editContactOptions: editContactOptionsReducer,
    commandBarActionStateMap: pendingActionsStateReducer,
} as ReducersMapObject<AppViewState>);

export default reducer;
